'use strict';

import dispatchDirective from './directive';
import checkinDirective from './checkin';
import manualDirective from './manual';

const MODULE_NAME = 'daupler.dispatch';

var app = angular.module(MODULE_NAME, [
]);

app.directive('betaDispatchContainer', dispatchDirective);
app.directive('betaCheckinContainer', checkinDirective);
app.directive('betaManualDispatch', manualDirective);

export default MODULE_NAME;
